// Quotation CustomerReview Stage related codes goes here

// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import { QuotationCustomerReviewBtns } from "../QuotationTopBarBtns";

// Declarations

export default function QuotationCustomerReviewStage(props) {
  return (
    <Fragment>
      <div className="document-meta">
        <div
          data-test="quotationtopbarbtns-document-meta"
          className="document-btns">
          <QuotationCustomerReviewBtns {...props} />
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationStages/QuotationCustomerReviewStage.js